import React, { useEffect, useState } from 'react';

/**
 * Loops through the words array with typewriter effect.
 */
export default function Typewriter({ words = [], speed = 90, pause = 1500, deleteSpeed = 45, className = '' }) {
  const [idx, setIdx] = useState(0);
  const [text, setText] = useState('');
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!words.length) return;
    const current = words[idx % words.length];
    let timeout;

    if (!deleting && text.length < current.length) {
      timeout = setTimeout(() => setText(current.slice(0, text.length + 1)), speed);
    } else if (!deleting && text.length === current.length) {
      timeout = setTimeout(() => setDeleting(true), pause);
    } else if (deleting && text.length > 0) {
      timeout = setTimeout(() => setText(current.slice(0, text.length - 1)), deleteSpeed);
    } else if (deleting && text.length === 0) {
      setDeleting(false);
      setIdx((i) => (i + 1) % words.length);
    }
    return () => clearTimeout(timeout);
  }, [text, deleting, idx, words, speed, pause, deleteSpeed]);

  return (
    <span className={className} aria-live="polite">
      {text}
      <span
        className="inline-block ml-0.5 w-[3px] align-middle animate-pulse"
        style={{ height: '0.9em', background: 'currentColor', borderRadius: 1 }}
      />
    </span>
  );
}
